import axiosClient, { AxiosResponse } from 'axios';
import { ChangePayload } from '@nx-frontend/shared/types';
import { getChatOptions } from '@nx-frontend/shared/utils/blocks';

// PATCH
export const updateChatConfiguration = async (
  payload: ChangePayload,
  apiUrl: string,
  orgId: string,
  configurationId: string,
  sessionId: string
): Promise<AxiosResponse> => {
  const options = getChatOptions(payload);

  const body = {
    title: payload.title,
    options,
  };

  return axiosClient.patch(`${apiUrl}/configurations/${configurationId}?orgId=${orgId}`, body, {
    headers: { 'session-id': sessionId },
  });
};
